import { render, staticRenderFns } from "./dietCard.vue?vue&type=template&id=6a3494b4&scoped=true&"
import script from "./dietCard.vue?vue&type=script&lang=js&"
export * from "./dietCard.vue?vue&type=script&lang=js&"
import style0 from "./dietCard.vue?vue&type=style&index=0&id=6a3494b4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a3494b4",
  null
  
)

export default component.exports